/**
 * Shopify Runtime Config Bootstrap
 * Builds window.SHOPIFY_CONFIG from server-rendered meta tags.
 */
(function() {
  'use strict';

  const getMeta = function(name) {
    const element = document.querySelector(`meta[name="${name}"]`);
    return element ? element.getAttribute('content') || '' : '';
  };

  window.SHOPIFY_CONFIG = {
    currency: getMeta('shopify-config-currency'),
    moneyFormat: getMeta('shopify-config-money-format'),
    moneyWithCurrencyFormat: getMeta('shopify-config-money-with-currency-format'),
    translations: {
      collectionsLabel: getMeta('shopify-config-i18n-collections-label'),
      productsLabel: getMeta('shopify-config-i18n-products-label'),
      searchingLabel: getMeta('shopify-config-i18n-searching-label'),
      searchUnavailableLabel: getMeta('shopify-config-i18n-search-unavailable-label'),
      noResultsLabel: getMeta('shopify-config-i18n-no-results-label'),
      collectionTypeLabel: getMeta('shopify-config-i18n-collection-type-label'),
      fromPriceLabel: getMeta('shopify-config-i18n-from-price-label'),
      quantityLabel: getMeta('shopify-config-i18n-quantity-label'),
      scrollToTopLabel: getMeta('shopify-config-i18n-scroll-to-top-label'),
      cartGenericError: getMeta('shopify-config-i18n-cart-generic-error'),
      cartQuantityError: getMeta('shopify-config-i18n-cart-quantity-error'),
      cartRemoveError: getMeta('shopify-config-i18n-cart-remove-error'),
      cartNoteError: getMeta('shopify-config-i18n-cart-note-error'),
      cartLoadError: getMeta('shopify-config-i18n-cart-load-error'),
      filtersApplyError: getMeta('shopify-config-i18n-filters-apply-error'),
      retryLabel: getMeta('shopify-config-i18n-retry')
    }
  };
})();
